import {
  beatOffsetSeconds,
  barsDurationSeconds,
  grooveBeatAnchor,
  hitDurationSeconds,
  runStamps,
  secondsPerSixteenth,
  toneTransportBpm,
} from './time';

Object.assign(globalThis, {
  PiandojoSoundTime: Object.freeze({
    beatOffsetSeconds,
    barsDurationSeconds,
    grooveBeatAnchor,
    hitDurationSeconds,
    runStamps,
    secondsPerSixteenth,
    toneTransportBpm,
  }),
});
